import blog1 from './images/slider-image3.png';
import blog2 from './images/blog-image4.png';
import blog3 from './images/slider-image_1.png';
import blog4 from './images/blog-image5.png';
import blog5 from './images/blog-image1.png';

let bloginfo = [
    {
        id: 1,
        postdate: '25 days ago',
        postimg: blog1,
        postheading: 'Living In Style',
        postdescription: `Welcome to Living in Style, where luxury meets comfort and elegance embraces practicality. We believe that life is not just about living; it's about creating a haven that reflects your unique personality and taste. At Living in Style, we curate an exquisite collection of home decor and furnishings that transform your living spaces into a true embodiment of your lifestyle.`
    },
    {
        id: 2,
        postdate: '8 days ago',
        postimg: blog2,
        postheading: 'French Cuisine',
        postdescription: `French cuisine holds an esteemed position in the culinary world, captivating food enthusiasts with its rich history, exquisite flavors, and artful presentations. Renowned as one of the most influential and celebrated cuisines globally, French culinary traditions have been shaped by a deep appreciation for quality ingredients, meticulous techniques, and a profound respect for regional diversity.`
    },
    {
        id: 3,
        postdate: '13 days ago',
        postimg: blog3,
        postheading: 'Healthy Mind ',
        postdescription: `A healthy mind is a sanctuary of balance, resilience, and clarity, nurturing wellness from within. Just as our bodies require nourishment and care, our minds deserve equal attention and mindfulness.`
    },
    {
        id: 4,
        postdate: '28 days ago',
        postimg: blog4,
        postheading: 'Italian Cuisine',
        postdescription: `Italian cuisine is a true celebration of rich flavors, vibrant colors, and time-honored culinary traditions. Renowned worldwide for its exquisite taste and diverse regional specialties, Italian dishes have won the hearts of food enthusiasts across the globe.`
    },
    {
        id: 5,
        postdate: '21 days ago',
        postimg: blog5,
        postheading: 'Embrace the Coastal Lifestyle',
        postdescription: `The beach isn't just a destination; it's a way of life. Our blog celebrates the coastal lifestyle, offering insights into the laid-back charm and relaxed atmosphere that comes with living near the sea. From tips on beach-inspired home decor to beach fashion trends, we'll help you infuse the coastal vibe into your everyday life, no matter where you are.`
    }
]
export default bloginfo;